<template>
    <shoppingDetail :shoppingInformationObject="shoppingInformationObjectLocal"/>
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { getSaleByCompanyIdAndUniqueId } from "@/app/components/shopping-detail/service/shopping-detail.service";

//Components
import shoppingDetail from "@/app/components/shopping-detail/shopping-detail";

export default {
    name: 'ShoppingDetailView',
    components: { shoppingDetail },
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },
    data: () => ({
        shoppingInformationObjectLocal: {},
        uniqueId: null
    }),
    created() {
        this.getUniqueId()
        this.getShoppingInformation()
    },
    methods: {
        getUniqueId() {
           this.uniqueId = window.location.search.replace('?uniqueId=', '')
        },
        getShoppingInformation() {
            getSaleByCompanyIdAndUniqueId(this.currentCompany.id, this.uniqueId)
                .then(success => {
                        this.shoppingInformationObjectLocal = success.data
                    }
                )
                .catch( error => error != null ? this.$toasted.show(error.message, { type: 'error' } ) : '')
        }
    }
}
</script>

<style scoped>

</style>